import logo from '@/assets/images/logo.svg'
import logoDark from '@/assets/images/logo_dark.svg'

export function useLogo(open: boolean) {
  return open ? logoDark : logo
}
